import React from 'react'
import { EMPLOYEES_SALARY_LIST } from '../../urls'
import { usePostRequest } from '../../hooks/request'
import EmployeeSalaryForm from './EmployeeSalaryForm'

export default function EmployeeSalaryCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: EMPLOYEES_SALARY_LIST })

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>

            <EmployeeSalaryForm loading={brandCreate.loading} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
